<template>
  <progress-bar
    :display-back="true"
    :image-source="levelComponent.progress"
    @quit="$emit('quit')"
  />
  <scrollable-content
    :loading="loading">
    <div
      class="header"
      v-if="currentProduct && position === 0">Ziel erreicht</div>
    <div
      class="header"
      v-else>Deine Alternative
    </div>
    <div
      class="title"
      v-if="currentProduct && position === 0">
      Das ist der perfekte Rucksack für dich!
    </div>
    <div
      class="product-slider"
      v-touch:swipe.left="swipeRight"
      v-touch:swipe.right="swipeLeft">
      <product
        class="mt-4"
        @add="addToCart"
        @swipeLeft="swipeLeft"
        @swipeRight="swipeRight"
        :reason="reason"
        :has-swipe-left="hasSwipeLeft"
        :has-swipe-right="hasSwipeRight"
        :name="currentProductData?.importName"
        :is-alternative="!currentProduct.main"
        :link="currentProductDataLink"
        :product="currentProductData"
        v-if="currentProductData"
      />
    </div>
  </scrollable-content>
</template>

<script>
  import { mapGetters } from 'vuex'
  import superagent from 'superagent'
  import ScrollableContent from '@/components/ScrollableContent'

  export default {
    components: {ScrollableContent},
    computed: {
      ...mapGetters({
        answers: 'answers'
      }),
      products() {
        return this.levelComponent.products.filter(product => {
          if (!product.depends) {
            return true
          }

          let results = product.depends.filter(value => {
            return this.answers.indexOf(value) > -1
          })
          return product.depends.length === 1
            ? results.length >= 1
            : results.length === product.depends.length
        })
      },
      currentProduct() {
        return this.products
          ? this.products[this.position]
          : null
      },
      currentProductData() {
        return this.productData
          ? this.productData[this.currentProduct.id]
          : null
      },
      currentProductDataLink() {
        let p = this.currentProductData
        if (p) {
          if (p.calculatedDetailLink) {
            let parsedLinks = JSON.parse(p.calculatedDetailLink)
            if (parsedLinks) {
              return parsedLinks.find(l => l.indexOf(this.$i18n.locale + '-' + this.$i18n.locale) > -1)
            }
          }
        }
      },
      hasSwipeLeft() {
        return this.products
          && this.position > 0
      },
      hasSwipeRight() {
        return this.products
          && this.position < (this.products.length - 1)
      },
      reason() {
        return this.currentProduct
        && this.$te('products.' + this.currentProduct.name)
          ? this.$t('products.' + this.currentProduct.name)
          : null
      }
    },
    data() {
      return {
        position: 0,
        loading: false,
        productData: []
      }
    },
    created() {
      this.loadProducts()
    },
    methods: {
      loadProduct(productId) {
        return superagent.post(process.env.VUE_APP_API_URL)
          .send({
            "query": "{getProduct(id: " + productId + "){productType\n modelId\n identifier\n importName\n calculatedDetailLink\n calculatedActiveColors\n children {\n ... on object_Product {\n productType\n modelId\n identifier\n calculatedHexCodes\n  calculatedImageLink\n  children {\n ... on object_Product {\n productType\n modelId\n identifier\n EAN\n calculatedPrices\n calculatedAddToCartLink\n }\n }\n }\n }\n }\n}\n",
            "variables": null,
            "operationName": null
          })
          .then(res => res.body)
          .then(res => {
            console.log(res.data.getProduct, productId)
            return res.data.getProduct
          })
          .finally(() => this.loading = false)
      },
      async loadProducts() {
        this.loading = true
        for (const p of this.products) {
          let response = await this.loadProduct(p.id)
          if (response) {
            this.productData[p.id] = response
          }
        }
        this.loading = false
      },
      swipeLeft() {
        if (this.hasSwipeLeft) {
          this.position--
        }
      },
      swipeRight() {
        if (this.hasSwipeRight) {
          this.position++
        }
      },
      addToCart($event) {
        this.trackEvent('addToCart', 'resultScreen-addToCart', {
            name: this.currentProductData?.importName,
            productId: $event
        })
        this.performAction({
          action: 'jump:RES-FIN'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    @apply
      mt-2
      px-6
      text-xl
      uppercase
      text-center
      text-ctm-primary;
  }

  .title {
    @apply
      px-4
      mt-1
      text-base
      text-center
      text-ctm-black;
  }

  .product-slider {
    @apply
      flex
      w-full
      overflow-x-hidden;
  }
</style>